export type NavigationBrandingLevel = 'Low' | 'Medium' | 'High';

export const navStyleMap: Map<NavigationBrandingLevel, 'neutral' | 'accent-neutral' | 'accent'> = new Map([
  ['Low', 'neutral'],
  ['Medium', 'accent-neutral'],
  ['High', 'accent'],
]);
